import { Container, Grid, TextField } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'

import { getTestimonials } from '../../services/Testimonials'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import history from '../../services/history'

function TestimonialPage() {
  const { setUser, setAboutCurrentPage } = useContext(Context)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }

    setAboutCurrentPage({
      title: 'Depoimentos'
      // buttons: [{ title: 'Adicionar Usuário', pathname: '/muralform' }],
    })

    getTestimonials().then(r => {
      console.log('testimonials', r)
    })
  }, [])

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container style={{ marginBottom: '25px', marginTop: '15px' }}>
            <Grid item xs={12}>
              <form noValidate autoComplete="off" style={{ marginTop: '20px' }}>
                <TextField fullWidth id="outlined-basic" label="Nome" variant="outlined" />
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default TestimonialPage
